import React, {Dispatch, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {HubConnection, HubConnectionBuilder} from '@microsoft/signalr';

import {User} from '../_services/User';
import {setConnectedState} from '../_actions/rtms';

type Notification = {
    subject: string;
    body: string;
};

type NotificationManagerProps = {
    dispatchRtmsConnected: () => void;
    dispatchRtmsReConnecting: () => void;
    dispatchRtmsDisconnected: () => void;
};

const NotificationManager: React.FunctionComponent<NotificationManagerProps> = ({
                                 dispatchRtmsConnected,
                                 dispatchRtmsReConnecting,
                                 dispatchRtmsDisconnected,
                             }): JSX.Element => {
    const [connection, setConnection] = useState<HubConnection>();
    const [activeNotifications, setActiveNotifications] = useState<Notification[]>([]);

    const hubUrl = '/rtms/hub';
    useEffect(() => {
        const newConnection = new HubConnectionBuilder()
            .withUrl(hubUrl, { accessTokenFactory: () => User.getInstance().getAuthToken() || '' })
            .withAutomaticReconnect()
            .build();
        setConnection(newConnection);
    }, []);

    useEffect(() => {
        if (!connection) return;

        connection.start()
            .then((result) => {
                console.log('connected!', result);
                dispatchRtmsConnected();

                connection.on('Notification', message => {
                    console.log('Received Notification', message);
                    setActiveNotifications((state: any) => ([
                        ...state,
                        message
                    ]));
                });

                connection.on('ConnectionId', message => {
                    console.log('ConnectionId', message);
                });

                connection.onclose(error => {
                    console.log('onclose called ', error);
                    dispatchRtmsDisconnected();
                });

                connection.onreconnecting(error => {
                    console.log('onreconnecting', error);
                    dispatchRtmsReConnecting();
                });

                connection.onreconnected(connectionId => {
                    console.log('onreconnected', connectionId);
                    dispatchRtmsConnected();
                });
            })
            .catch((error) => {
                // silently die, not critical
                // TODO: need to log somewhere for tracking
                console.log('Error starting connection', error);
            })
    }, [connection]);

    return (
        <div className="notification-container"
            aria-live="polite"
             aria-atomic="true"
        >
            {activeNotifications.map((notification: Notification, index: number) => (
                <div key={index}
                    className="notification toast show"
                     role="alert"
                     aria-live="assertive"
                     aria-atomic="true"
                >
                    <div className="toast-header">
                        <i className="fas fa-exclamation-circle mr-2" />
                        <strong className="mr-auto">{notification.subject}</strong>
                        <button type="button"
                                className="ml-2 mb-1 close"
                                aria-label="Close"
                                onClick={() => {
                                    setActiveNotifications((state: any) => ([
                                        ...state.slice(0, index),
                                        ...state.slice(index + 1)
                                    ]));
                                }}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="toast-body">
                        {notification.body}
                    </div>
                </div>
            ))}
        </div>
    )
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
    return {
        dispatchRtmsConnected: () => {
            dispatch(setConnectedState('Connected'));
        },
        dispatchRtmsReConnecting: () => {
            dispatch(setConnectedState('ReConnecting'));
        },
        dispatchRtmsDisconnected: () => {
            dispatch(setConnectedState('Disconnected'));
        }
    };
};

// @ts-ignore
const ConnectedNotificationManager = connect(null, mapDispatchToProps)(NotificationManager);
export {ConnectedNotificationManager as NotificationManager};